import { memo } from 'react';
import { Avatar } from '@aimsos/ui';
import { getWidgetLibraryAvatarSrc } from '../constants/widgetLibraryAvatarImages';

const WidgetLibraryAvatar = ({ widget, selected }) => {
  const src = getWidgetLibraryAvatarSrc(widget?.type);

  return (
    <span
      className={[
        'inline-flex shrink-0 rounded-full',
        selected ? 'ring-1 ring-brand-500/50 ring-offset-0' : '',
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <Avatar
        size="sm"
        src={src}
        alt={widget?.name ? `${widget.name} — preview` : 'Widget preview'}
      />
    </span>
  );
};

export default memo(WidgetLibraryAvatar);
